module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hant/5/1-de9f038c8258763528855076bc07aa2d.jpg";